import React, { useContext } from "react";
import { Button, Modal, Tabs } from "antd";
import MerchantLayout from "../../layout/MerchantLayout";
import MerchantPOFromSupplier from "./po";
import MerchantDeliveryFromSupplier from "./delivery";
import { SubscriptionInfo, UserInfo } from "../../../context";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import MerchantReturnToSupplier from "./return";
// import MerchantPOFromSupplier from "./po";
// import MerchantDeliveryFromSupplier from "./delivery";
// import MerchantLayout from "../../layout/MerchantLayout";

const MerchantDelivery = () => {
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const { handleLogoutTkn } = useContext(UserInfo);
  const navigate = useNavigate();

  const items = [
    {
      key: "1",
      label: `Purchase Order`,
      children: <MerchantPOFromSupplier />,
    },
    {
      key: "2",
      label: `Receiving`,
      children: <MerchantDeliveryFromSupplier />,
    },
    {
      key: "3",
      label: `Return`,
      children: <MerchantReturnToSupplier />,
    },
  ];

  return (
    <MerchantLayout>
      <Tabs defaultActiveKey="1" items={items} />

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantLayout>
  );
};

export default MerchantDelivery;
